export const TeamExtensions = {
  ALL_TEAMS: { id: 'all-teams', name: 'All Teams' },
  OTHER_BUSINESS_UNIT: { id: 'other-business-unit', name: 'Other Business Unit' },
  UNDEFINED_TEAM: { id: 'undefined-team', name: 'Undefined Team' }
}

export const DuplicateTeamMemberError = (
  numberOfDuplicates?: string,
  firstMemberBooked?: string,
  bookedMemberClub?: string
) => {
  return {
    ONE_MEMBER_DUPLICATE: `${firstMemberBooked} has a space booked at ${bookedMemberClub} for this day so will not be added to your booking`,
    MORE_THAN_ONE_MEMBER_BOOKED: `There are ${numberOfDuplicates} guests that already have spaces booked at ${bookedMemberClub} for this day so will not be added to your booking`
  }
}

export enum ErrorMessages {
  NO_SEATS_AVAILABLE = 'Sorry, there are no seats available please select another date.'
}
